<script>
/**
 * Muro de pago del portal.
 *
 * Se muestra en lugar del contenido que la app cobra (Sesiones y Negocios)
 * cuando el cliente no tiene una suscripción vigente en Stripe.
 *
 * Desde que el portal permite contratar, este muro lleva a "Mi cuenta" en vez
 * de remitir a la app: antes era un callejón sin salida para quien estaba
 * navegando desde una computadora.
 */
export default {
  props: {
    seccion: { type: String, default: "esta sección" },
  },
};
</script>

<template>
  <div class="membresia-card text-center">
    <i class="mdi mdi-lock-outline membresia-icono"></i>
    <h2 class="h4 mt-3">{{ seccion }} es parte de Recnet Plus</h2>
    <p class="text-muted mb-4">
      Tu cuenta no tiene una membresía activa. Con Recnet Plus tienes acceso a las sesiones
      completas y al directorio de negocios de la red.
    </p>

    <router-link :to="{ name: 'portal-cuenta' }" class="btn btn-primary">
      Activar Recnet Plus
    </router-link>

    <p class="text-muted small mt-4 mb-0">
      También puedes activarla desde la app. Si acabas de suscribirte, vuelve a cargar esta página.
    </p>
  </div>
</template>

<style scoped>
.membresia-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 48px 24px;
  max-width: 560px;
  margin: 32px auto;
}

.membresia-icono {
  font-size: 56px;
  color: #f1b44c;
}

</style>
